import React from 'react';
import SimpleCrud from '../components/SimpleCrud';

export default function Halls() {
  return <SimpleCrud title="Halls" basePath="halls" fields={[
    { key: 'name', label: 'Hall name' },
    { key: 'address', label: 'Address' },
    { key: 'city', label: 'City' },
  ]} />;
}
